import * as React from "react";
import * as learn from "./style.module.scss";
import * as main from "../../main.module.scss";
export const Learn = () => {
  return (
    <section className={`${learn.learn} ${main.hugs}`}>
      <div className="container">
        <div className={`${main.container} ${main.orange}`}>
          <h2 className={main.title}>Обсудим как учиться, если:</h2>
          <div className={learn.wrap}>
            <ul>
              <li><p>Плохая память, а от зубрежки тошнит 🤮</p></li>
              <li><p>Трудно и не получается</p></li>
              <li><p>Домашку без ГДЗ не сделать и контрольные пишутся все хуже и хуже</p></li>
              <li><p>Есть отставание по предметам, которое растет и скоро станет критическим</p></li>
            </ul>
            <div className={learn.img}>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/photo-01.png" alt=""/>
            </div>
          </div>
          <div className={`${learn.wrap} ${learn.left}`}>
            <div className={learn.img}>
              <img src="https://fs.advance.ru/landing-pages/webinar/legko_uchitsya/photo-02.png" alt=""/>
            </div>
            <ul>
              <li><p>Родители постоянно спрашивают про выбор специальности, но об этом нет даже мыслей</p></li>
              <li><p>Трудности с точными дисциплинами</p></li>
              <li><p>Трудности с гуманитарными предметами</p></li>
              <li><p>Педагоги постоянно задают бесполезные задания в которых не видно никакого смысла</p></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
